/* eslint-disable no-console */
import {Flex} from 'antd';
import React, {useState} from 'react';

import {ReactComponent as Location} from '../../../assets/location_logo.svg';
import logoutModal from '../../../assets/Log_Out.svg';
import settingodal from '../../../assets/settings_white.svg';
import upgradePlan from '../../../assets/upgradeplan_modal.svg';
import useCompanyStore from '../../../store/companyStore/companyDetailsStore';
import useJSONStore from '../../../store/StaticJson/jsonStore';
import {FirstCap} from '../../../utils/FormUtils/FirstCap';

const HeaderComponent: React.FC<{
  setShowTour: React.Dispatch<React.SetStateAction<boolean>>;
}> = ({setShowTour}) => {
  const [showModal, setShowModal] = useState(false);
  const companyDetails = useCompanyStore.getState().companyDetails;
  const countryDetails = useJSONStore((state) => state.country)?.find(
    (item) => item?.value === companyDetails?.registeredHeadOfficeCountry
  );
  const openModal = () => {
    setShowModal((prev) => !prev);
  };

  const planType = useCompanyStore.getState().subscription?.planType;

  return (
    <div style={{height: '320px'}}>
      <Flex className="climate-banner">
        <div className="climate-card">
          <div className="startPlan">
            <div className="plan-badge">
              {FirstCap(planType?.toLowerCase())} Plan
            </div>
            <div className="settingGroup">
              <div
                className="takeTour"
                onClick={() => {
                  setShowTour(true);
                }}
              >
                Take a Tour
              </div>
            </div>
          </div>
          {showModal && (
            <div className="modalClass">
              <div className="menuList">
                <img src={settingodal} alt="setting" onClick={openModal} />
                <span className="modalText">Settings</span>
              </div>
              <div className="menuList">
                <span>
                  <img src={upgradePlan} alt="plan" onClick={openModal} />
                </span>
                <span className="modalText">Upgrade Plan</span>
              </div>
              <div className="menuList">
                <span>
                  <img src={logoutModal} alt="logout" onClick={openModal} />
                </span>
                <span className="modalText">Logout</span>
              </div>
            </div>
          )}
          <Flex gap={6} vertical justify="space-between">
            <div className="profile-title">Climate Profile</div>
            <div className="company-name">{companyDetails?.companyName}</div>
            <hr className="divider" style={{margin: '12px 0px 0px 0px'}} />
            <Flex className="address" style={{alignItems: 'center'}}>
              <Flex align="flex-start" vertical={false}>
                <Flex>
                  <Location />
                </Flex>
                <Flex wrap="wrap">
                  {companyDetails?.registeredHeadOfficeAddress}
                </Flex>
              </Flex>
              <div style={{display: 'flex', alignItems: 'center'}}>
                {countryDetails?.countryCode !== undefined ? (
                  <img
                    src={`https://flagsapi.com/${countryDetails?.countryCode}/flat/24.png`}
                    style={{
                      marginRight: '5px'
                    }}
                  />
                ) : (
                  <></>
                )}
                {countryDetails?.label}
              </div>
            </Flex>
            <hr className="divider" style={{margin: '0px 0px 12px 0px'}} />
          </Flex>
        </div>
      </Flex>
    </div>
  );
};

export default HeaderComponent;
